import React, { useEffect, useState } from "react";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import EditDeleteIcon from "../../CustomComponents/EditDeleteIcon";
import moment from "moment";
import { DeleteConfirmModal } from "../../CustomComponents/DeleteConfirmModal";
import { ImCross } from "react-icons/im";
const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "35px",
  fontWeight: "bold",
};
const customStyles = {
  rows: {
    style: {
      minHeight: "24px", // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: "18px", // override the cell padding for head cells
      paddingRight: "8px",
      backgroundColor: "#cee0eb", // set the background color for head cells
    },
  },
};

const Services = () => {
  const [Services, setServices] = useState("");
  const [Company, setCompany] = useState("");
  const [CompanyIdWiseServices, setCompanyIdWiseServices] = useState("");
  const [CompanyList, setCompanyList] = useState([]);

  const [ServicesID, setServicesID] = useState("");
  const [AllData, setAllData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isEdit, setisEdit] = useState(false);

  //Add type
  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!Company && !ServicesID) {
    //     toast.error("Please fill all fields.")
    // }
    setisLoading(true);
    const data = {
      companyTypeID: Company,
      name: Services,
    };
    const res = await HttpClient.requestData("add-service", "POST", data);
    if (Services !== "" && Company !== "") {
      if (res && res?.status) {
        setisLoading(false);
        setServices("");
        setCompany("");
        toast.success("Data submitted");
        getServices();
      } else {
        setisLoading(false);
        toast.error("Something is wrong");
      }
    } else {
      setisLoading(false);

      toast.error("Field cant empty");
    }
  };

  const columns = [
    {
      name: "SL",
      selector: (row) => row.sl,
      width: "10%",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      width: "40%",
    },
    {
      name: "Date",
      selector: (row) => row.createdOn,
      width: "30%",
    },
    {
      name: "Action",
      selector: (row) => row.action,
      width: "20%",
    },
  ];

  // get company
  const getTypeOfCompanies = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData("view-companyType", "GET", {});
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      setCompanyList(res?.data);
    } else {
      setisLoading(false);
    }

    setAllData(apiData);
  };
  // get servicec
  const getServices = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData(
      "companyType-wise-service/" + CompanyIdWiseServices,
      "GET",
      {}
    );
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      apiData = res?.data?.map((item, i) => ({
        sl: i + 1,
        name: item?.name,
        createdOn: moment(item?.createdOn).format("DD-MM-YYYY"),

        action: (
          <EditDeleteIcon
            onClickEdit={(e) => handleEdit(item)}
            onClickDelete={(e) => handleDelete(item?._id)}
          />
        ),
      }));
    } else {
      setisLoading(false);
    }

    setAllData(apiData);
  };
  //Delete part
  const handleDelete = (id) => {
    const del = async () => {
      setisLoading(true);
      const res = await HttpClient.requestData(
        "delete-service/" + id,
        "DELETE"
      );
      if (res && res?.status) {
        setisLoading(false);
        getServices();

        toast.success("id Deleted Successfully");
      } else {
        setisLoading(false);
        toast.error(res?.message || "Something Wrong");
      }
    };

    DeleteConfirmModal(del);
  };
  //Edit
  const handleEdit = async (item) => {
    setisEdit(true);
    setCompany(item?.companyTypeID);
    setServicesID(item?._id);
    setServices(item?.name);
  };
  //cancel edit
  const cancelEdit = (e) => {
    setisEdit(false);
    setServices("");
    setServicesID("");
  };
  // edit submit
  const handleEditSubmit = async (e) => {
    // console.log("valuesdd");
    e.preventDefault();

    if (!Services) {
      toast.error("Input blank");
      return;
    }

    const data = {
      name: Services,
    };
    setisLoading(true);
    const res = await HttpClient.requestData(
      "update-service/" + ServicesID,
      "PUT",
      data
    );
    // console.log("resCat", res)
    if (res && res?.status) {
      toast.success("Added Successfully");
      setisEdit(false);
      setServices("");
      setCompany("");
      setisLoading(false);
      getServices();
    } else {
      toast.error(res?.message || "Something Wrong");
      setisLoading(false);
    }
  };

  useEffect(() => {
    getTypeOfCompanies();
  }, []);
  useEffect(() => {
    getServices();
  }, [CompanyIdWiseServices]);
  return (
    <div>
      <CustomLoader loading={isLoading} />

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <div style={headLineStyle} className="page-headline">
              Add Services
            </div>
            <form>
              <div className="row">
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Company Type<span className="text-danger">&nbsp;*</span>
                  </label>
                  <select
                    type="text"
                    className="form-control"
                    placeholder="Company Name Name"
                    name=""
                    value={Company}
                    onChange={(e) => setCompany(e.target.value)}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {CompanyList?.map((item, i) => {
                      return (
                        <>
                          <option value={item?._id}>{item?.type}</option>
                        </>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-12 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Services Name<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Services Name"
                    name=""
                    value={Services}
                    onChange={(e) => setServices(e.target.value)}
                  />
                </div>
              </div>

              {/* Button */}
              <div className="col-12 d-flex justify-content-end ">
                {isEdit ? (
                  <div className=" d-flex ">
                    <button
                      type="submit"
                      onClick={(e) => handleEditSubmit(e)}
                      className="btn btn-primaryb mt-3 btn-grad"
                      // style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                    >
                      Update Data
                    </button>
                    <ImCross
                      onClick={(e) => cancelEdit(e)}
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      className=" mx-3 mt-4 text-danger "
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    onClick={(e) => handleSubmit(e)}
                    className="btn btn-primaryb mt-3"
                    style={{
                      background:
                        "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))",
                      color: "#fff",
                    }}
                  >
                    Add Data
                  </button>
                )}
              </div>
            </form>
            <div className="mt-2">
              <div style={headLineStyle} className="page-headline">
                Company Type wise Services
              </div>
              <div className="col-md-6 mt-2 ">
                <label htmlFor="formGroupExampleInput">
                  Select Company Type
                  <span className="text-danger">&nbsp;*</span>
                </label>
                <select
                  type="text"
                  className="form-control"
                  placeholder="Company Name Name"
                  name=""
                  value={CompanyIdWiseServices}
                  onChange={(e) => setCompanyIdWiseServices(e.target.value)}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {CompanyList?.map((item, i) => {
                    return (
                      <>
                        <option value={item?._id}>{item?.type}</option>
                      </>
                    );
                  })}
                </select>
              </div>
              <DataTable
                columns={columns}
                data={AllData}
                pagination
                striped
                className=" rounded mt-1"
                customStyles={customStyles}
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Services;
